import React, { useEffect, useState } from 'react';
import { GetUserVulnerabilityData, GetVulnerabilityData } from 'services/MyRacService';
import { loggerFunc } from 'utils/logger';
import { useNavigate } from 'react-router-dom';
import { VULNERABLE_CUSTOMERS } from 'constants/routeConstants';
import Spinner from 'components/Spinner';
import trackEvent from 'services/AnalyticsService';

export type TVulnerability = {
  id: number;
  description: string;
}

const HelpAndSupportPanel = () => {
  const logger = loggerFunc('VulnerableCustomers');
  const navigate = useNavigate();
  const [vulnerabilities, setVulnerabilities] = useState<TVulnerability[]>([]);
  const [selected, setSelected] = useState<number[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [vulnerabilityData, userVulnerabilityData] = await Promise.all([
          GetVulnerabilityData(),
          GetUserVulnerabilityData(),
        ]);

        if (vulnerabilityData) setVulnerabilities(vulnerabilityData);
        if (userVulnerabilityData) setSelected(userVulnerabilityData);
      } catch (err) {
        logger.debug(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const selectedVulnerabilities = selected.length > 0 ? vulnerabilities?.filter((v) => selected.includes(v.id)) : [];
  const addComa = selected.length > 1 ? ', ' : '';

  return (
    <div className="col-12 col-sm-6">
      <div className="tile box">
        <h4>Help and support</h4>
        {loading ? <div className="d-flex justify-content-center pt-3"><Spinner iconSpinner /></div> : (
          <div className="Info rac-form">
            <div>
              <p className="long primary">
                {selectedVulnerabilities.length > 0
                ? selectedVulnerabilities.map((v, i) => `${(i > 0) ? addComa : ''} ${v.description}`)
                : 'None provided'}
              </p>
              <p className="action edit">
                <button
                  type="button"
                  className="MyRacForm__button-link link Panel__button"
                  onClick={() => {
                    trackEvent('MyRAC_VulnerableCustomers_PersonalDetails_Panel_Link');
                    navigate(VULNERABLE_CUSTOMERS)
                  }}
                >
                  Change support needs
                </button>
              </p>
            </div>
          </div>
          )}
      </div>
    </div>
  );
}

export default HelpAndSupportPanel;
